import { render, staticRenderFns } from "./publicHighlight.vue?vue&type=template&id=2395c60f&scoped=true&"
import script from "./publicHighlight.vue?vue&type=script&lang=babel&"
export * from "./publicHighlight.vue?vue&type=script&lang=babel&"
import style0 from "./publicHighlight.vue?vue&type=style&index=0&id=2395c60f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395c60f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VCardText,VCardTitle,VOverlay})
